import { z } from 'zod';

export const loginValidationSchema = z.object({
  login: z.string().min(1, 'Digite seu e-mail ou CPF'),
});

export type LoginValidationData = z.infer<typeof loginValidationSchema>;
